// extracted by css-extract-rspack-plugin
export default {"root":"ZDu358","container":"bN1cCS","logo":"XGZbB1","message":"hAGHR5","input":"xmoCWm","signInRow":"ybs0YU"};